import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {setBearerToken} from '../../../repositories/api_helper'

const initialState = {
    user: null,
    roles: []
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        storeUser: (state, action) => {
            const user = action.payload
            setBearerToken(user.access_token)
            state.user = user
        },
        storeUserRoles: (state, action: PayloadAction<any>) => {
            state.roles = action.payload;
        }
    },
});

export const {
    storeUser,
    storeUserRoles
} = authSlice.actions;

export const selectUser = state => state.auth.user
export const selectUserRoles = state => state.auth.roles
export default authSlice.reducer;
